<template>
  <div class="enter-plan">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h2>网络月计划任务</h2>
      </div>
      <div class="text item">
        <el-row>
          <el-col :span="12">
            <el-select v-model="value_name" placeholder="选择项目" @change="hostIdChange">
              <el-option
                v-for="item in result"
                :key="item.hos_id"
                :label="item.hos_name"
                :value="item.hos_id + ',' +item.hos_name"
              ></el-option>
            </el-select>
            <el-date-picker
              v-model="date_value"
              type="date"
              placeholder="选择日期"
              format="yyyy - MM - dd"
              value-format="yyyy-MM-dd"
              @change="dateChange"
            ></el-date-picker>
          </el-col>
          <el-col :span="12" style="text-align:right">
            <el-button>
              <!-- <a
                href="http://test.report.jgyljt.com/default.xlsx"
                target="_blank"
                style="color: #606266"
              >下载导入模板</a> -->
              <a
                href="https://report.jgyljt.com/default.xlsx"
                target="_blank"
                style="color: #606266"
              >下载导入模板</a>
            </el-button>
            <el-upload
              class="upload-demo"
              ref="upload"
              :show-file-list="false"
              accept="file"
              :action="uploadDrugProductFileUrl"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :data="this.postUpload()"
              :auto-upload="true"
            >
              <el-button slot="trigger" type="info">导入数据</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <div style="text-align:center; color: #868686;margin-top:20px" v-show="dataShow == true">暂无数据</div>
        <table border="0" v-show="!dataShow">
          <thead>
            <tr>
              <th>日期</th>
              <th>渠道</th>
              <th>消费</th>
              <th>对话</th>
              <th>确诊对话</th>
              <th>到诊</th>
              <th>到诊转化率</th>
              <th>对话成本</th>
              <th>确诊对话成本</th>
              <th>到诊成本</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{date_value}}</td>
              <td>竞价</td>
              <td>{{jj_cost_price}}</td>
              <td>{{jj_dialog_count}}</td>
              <td>{{jj_sure_count}}</td>
              <td>{{jj_in_count}}</td>
              <td>{{jj_in_rate}} %</td>
              <td>{{jj_dialog_base}}</td>
              <td>{{jj_sure_base}}</td>
              <td>{{jj_in_base}}</td>
              <td>
                <span v-for="item in jjArr" v-show="arrShow"></span>
                <el-button @click="editClick(jjArr,1,'竞价')" type="primary">编辑</el-button>
              </td>
            </tr>
            <tr>
              <td>{{date_value}}</td>
              <td>优化</td>
              <td>{{yh_cost_price}}</td>
              <td>{{yh_dialog_count}}</td>
              <td>{{yh_sure_count}}</td>
              <td>{{yh_in_count}}</td>
              <td>{{yh_in_rate}} %</td>
              <td>{{yh_dialog_base}}</td>
              <td>{{yh_sure_base}}</td>
              <td>{{yh_in_base}}</td>
              <td>
                <span v-for="item in yhArr" v-show="arrShow"></span>
                <el-button @click="editClick(yhArr,2,'优化')" type="primary">编辑</el-button>
              </td>
            </tr>
            <tr>
              <td>{{date_value}}</td>
              <td>门户</td>
              <td>{{mh_cost_price}}</td>
              <td>{{mh_dialog_count}}</td>
              <td>{{mh_sure_count}}</td>
              <td>{{mh_in_count}}</td>
              <td>{{mh_in_rate}} %</td>
              <td>{{mh_dialog_base}}</td>
              <td>{{mh_sure_base}}</td>
              <td>{{mh_in_base}}</td>
              <td>
                <span v-for="item in mhArr" v-show="arrShow"></span>
                <el-button @click="editClick(mhArr,3,'门户')" type="primary">编辑</el-button>
              </td>
            </tr>
            <tr>
              <td>{{date_value}}</td>
              <td>新媒体</td>
              <td>{{xmt_cost_price}}</td>
              <td>{{xmt_dialog_count}}</td>
              <td>{{xmt_sure_count}}</td>
              <td>{{xmt_in_count}}</td>
              <td>{{xmt_in_rate}} %</td>
              <td>{{xmt_dialog_base}}</td>
              <td>{{xmt_sure_base}}</td>
              <td>{{xmt_in_base}}</td>
              <td>
                <span v-for="item in xmtArr" v-show="arrShow"></span>
                <el-button @click="editClick(xmtArr,5,'新媒体')" type="primary">编辑</el-button>
              </td>
            </tr>
            <tr>
              <td>{{date_value}}</td>
              <td>资源合作</td>
              <td>{{zyhz_cost_price}}</td>
              <td>{{zyhz_dialog_count}}</td>
              <td>{{zyhz_sure_count}}</td>
              <td>{{zyhz_in_count}}</td>
              <td>{{zyhz_in_rate}} %</td>
              <td>{{zyhz_dialog_base}}</td>
              <td>{{zyhz_sure_base}}</td>
              <td>{{zyhz_in_base}}</td>
              <td>
                <span v-for="item in zyhzArr" v-show="arrShow"></span>
                <el-button @click="editClick(zyhzArr,6 ,'资源合作')" type="primary">编辑</el-button>
              </td>
            </tr>
            <tr>
              <td>{{date_value}}</td>
              <td>无轨迹</td>
              <td>{{wgj_cost_price}}</td>
              <td>{{wgj_dialog_count}}</td>
              <td>{{wgj_sure_count}}</td>
              <td>{{wgj_in_count}}</td>
              <td>{{wgj_in_rate}} %</td>
              <td>{{wgj_dialog_base}}</td>
              <td>{{wgj_sure_base}}</td>
              <td>{{wgj_in_base}}</td>
              <td>
                <span v-for="item in wgjArr" v-show="arrShow"></span>
                <el-button @click="editClick(wgjArr, 7,'无轨迹')" type="primary">编辑</el-button>
              </td>
            </tr>
            <tr>
              <td>{{date_value}}</td>
              <td>其他</td>
              <td>{{qt_cost_price}}</td>
              <td>{{qt_dialog_count}}</td>
              <td>{{qt_sure_count}}</td>
              <td>{{qt_in_count}}</td>
              <td>{{qt_in_rate}} %</td>
              <td>{{qt_dialog_base}}</td>
              <td>{{qt_sure_base}}</td>
              <td>{{qt_in_base}}</td>
              <td>
                <span v-for="item in qtArr" v-show="arrShow"></span>
                <el-button @click="editClick(qtArr,4, '其他')" type="primary">编辑</el-button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <el-dialog
        title="数据编辑"
        :visible.sync="dialogVisible"
        width="450px"
        :before-close="handleClose"
      >
        <div class="dialog_head">
          <span class="value">选择时间：{{date_value}}</span>
          <span class="value_name">所属医院：{{value_name}}</span>
          <span>渠道：{{name}}</span>
        </div>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="消费">
            <el-input v-model="form.cost_price"></el-input>
          </el-form-item>
          <el-form-item label="有效对话">
            <el-input v-model="form.dialog_count"></el-input>
          </el-form-item>
          <el-form-item label="确诊对话">
            <el-input v-model="form.sure_count"></el-input>
          </el-form-item>
          <el-form-item label="到诊">
            <el-input v-model="form.in_count"></el-input>
          </el-form-item>
        </el-form>
        <div class="total">
          <div class="total-left">
            <span v-if="dialog_base == 'Infinity'">
              对话成本
              <span>0</span> 元/人
            </span>
            <span v-else>
              对话成本
              <span>{{dialog_base}}</span>元/人
            </span>
            <span v-if="in_base == 'Infinity'">
              到诊成本
              <span>0</span> 元/人
            </span>
            <span v-else>
              到诊成本
              <span>{{in_base}}</span>元/人
            </span>
          </div>
          <div class="total-left">
            <span v-if="in_rate == 'NaN' || in_rate == 'Infinity'">
              到诊转化率
              <span>0</span> %
            </span>
            <span v-else>
              到诊转化率
              <span>{{in_rate}}</span> %
            </span>
            <span v-if="sure_base == 'Infinity'">
              确诊对话成本
              <span>0</span> 元/人
            </span>
            <span v-else>
              确诊对话成本
              <span>{{sure_base}}</span> 元/人
            </span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelClick">取 消</el-button>
          <el-button type="primary" @click="submitClick">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
function UrlSearch() {
   var name,value;
   var str=location.href; //取得整个地址栏
   var num=str.indexOf("?")
   str=str.substr(num+1); //取得所有参数   stringvar.substr(start [, length ]
   var arr=str.split("&"); //各个参数放到数组里
    var arrtemp = arr[0].split('=')
    if (arrtemp != null) return unescape(arrtemp[1]);
}
    //获取GET id值
var info_id = UrlSearch();
import { mapState } from "vuex";
import { getCurrentTime, computedCost,  urlParse} from "@/assets/js/_mm.js";

import axios from "axios";
export default {
  name: "Home",
  data() {
    return {
      userid: '',
      fileList:[],
      result: [],
      value: "",
      id: "",
      date_value: "",
      arrShow: false,
      name: "",
      type: "",
      dataShow: false,
      value_name: "",
      dialogVisible: false,
    //   uploadDrugProductFileUrl: "http://test.report.jgyljt.com/phal/public/",
      uploadDrugProductFileUrl: "https://report.jgyljt.com/phal/public/",
      form: {
        in_count: "",
        cost_price: "",
        dialog_count: "",
        sure_count: ""
      },
      // 竞价
      jj_in_count: "",
      jj_dialog_count: "",
      jj_sure_count: "",
      jj_cost_price: "",
      jj_in_base: "",
      jj_dialog_base: "",
      jj_in_rate: "",
      jj_sure_base: "",
      jjArr: "",

      // 优化
      yh_in_count: "",
      yh_dialog_count: "",
      yh_sure_count: "",
      yh_cost_price: "",
      yh_in_base: "",
      yh_dialog_base: "",
      yh_in_rate: "",
      yh_sure_base: "",
      yhArr: "",

      // 门户
      mh_in_count: "",
      mh_dialog_count: "",
      mh_sure_count: "",
      mh_cost_price: "",
      mh_in_base: "",
      mh_in_rate: "",
      mh_dialog_base: "",
      mh_sure_base: "",
      mhArr: "",

      // 新媒体
      xmt_in_count: "",
      xmt_dialog_count: "",
      xmt_sure_count: "",
      xmt_cost_price: "",
      xmt_in_base: "",
      xmt_in_rate: "",
      xmt_dialog_base: "",
      xmt_sure_base: "",
      xmtArr: "",

      // 资源合作
      zyhz_in_count: "",
      zyhz_dialog_count: "",
      zyhz_sure_count: "",
      zyhz_cost_price: "",
      zyhz_in_base: "",
      zyhz_in_rate: "",
      zyhz_dialog_base: "",
      zyhz_sure_base: "",
      zyhzArr: "",

      // 无轨迹
      wgj_in_count: "",
      wgj_dialog_count: "",
      wgj_sure_count: "",
      wgj_cost_price: "",
      wgj_in_base: "",
      wgj_in_rate: "",
      wgj_dialog_base: "",
      wgj_sure_base: "",
      wgjArr: "",

      // 其他
      qt_in_count: "",
      qt_dialog_count: "",
      qt_sure_count: "",
      qt_cost_price: "",
      qt_in_base: "",
      qt_in_rate: "",
      qt_dialog_base: "",
      qt_sure_base: "",
      qtArr: ""
    };
  },
  computed: {
    in_base() {
      if(this.form.cost_price == 0) {
        return '-'
      }else {
        return Math.round(this.form.cost_price / this.form.in_count);
      }
    },
    sure_base() {
      if(this.form.cost_price == 0) {
        return '-'
      }else {
        return Math.round(this.form.cost_price / this.form.sure_count);
      }
    },
    dialog_base() {
      if(this.form.cost_price == 0) {
        return '-'
      }else {
        return Math.round(this.form.cost_price / this.form.dialog_count);
      }
    },
    in_rate() {
      return Math.round((this.form.in_count / this.form.dialog_count) * 100).toFixed(2);
    }
  },
  methods: {
    computedCost,
    dateChange(value) {
      this.date_value = value;
      this.getDayList();
    },
    hostIdChange(value) {
      let values = value.split(",");
      this.value = values[0];
      this.value_name = values[1];
      this.getDayList();
    },
    getHospInfo(callback) {
      axios
        .get("/phal/public/", {
          params: {
            s: "App.Day.HosList",
            userid: info_id
          }
        })
        .then(res => {
          let result = res.data;
          if (result.ret && result.ret === 200) {
            this.result = res.data.data;
            this.$nextTick(() => {
              this.value_name =  res.data.data[0].hos_name
            })
            callback();
            this.date_value = getCurrentTime();
          } else if (result.ret == 403) {
            this.$message.error(result.msg);
          }
        });
    },
    postUpload () {
      let hos_id;
      if(this.value == '') {
        hos_id = this.result[0].hos_id
      }else {
        hos_id = this.value
      }
      return {
        s:'App.Day.Export',
        userid: info_id,
        hos_id: hos_id
      }
    },
    uploadSuccess: function(e) {
      if(e.ret == 200 ) {
        this.$message.success("导入成功", () => {
        });
        this.getDayList()
      }else {
        this.$message.error(e.msg, () => {
        });
      }
    },
    uploadError: function(e) {
      this.$message.error("上传失败! ", function() {});
    },
    editClick(item, type, name) {
      this.dialogVisible = true;
      this.name = name;
      this.type = type;
      this.form.cost_price = item[0].cost_price;
      this.form.in_count = item[0].in_count;
      this.form.dialog_count = item[0].dialog_count;
      this.form.sure_count = item[0].sure_count;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancelClick() {
      this.dialogVisible = false;
    },
    submitClick() {
      this.dialogVisible = false;
      axios
        .get("/phal/public/", {
          params: {
            s: "App.Day.Edit",
            userid: info_id,
            id: this.id,
            qudao_id: this.type,
            cost_price: this.form.cost_price,
            in_count: this.form.in_count,
            dialog_count: this.form.dialog_count,
            sure_count: this.form.sure_count
          }
        })
        .then(res => {
          let result = res.data;
          if (result.ret && result.ret === 200 && result.data == 1) {
            this.$message.success("编辑成功");
            this.getDayList()
          } else if (result.ret == 403) {
            this.$message.error(result.msg);
          }
        });
    },
    getDayList() {
      let idValue;
      if (this.date_value == "") {
        this.date_value = getCurrentTime();
      }
      if(this.value == '') {
        idValue = this.result[0].hos_id
      }else {
        idValue = this.value
      }
      axios
        .get("/phal/public/", {
          params: {
            s: "App.Day.Index",
            date: this.date_value,
            hos_id: idValue,
            userid: info_id
          }
        })
        .then(res => {
          console.log(res);
          let result = res.data;
          if (result.ret && result.ret === 200) {
            let data = result.data;
            if (Object.keys(data).length > 0) {
              this.dataShow = false
              // 竞价
              let jjArr = [],  yhArr = [], mhArr = [], xmtArr = [], zyhzArr = [], wgjArr = [], qtArr = [];
              this.id = data.id;
              this.jj_in_count = data.jj_in_count;
              this.jj_dialog_count = data.jj_dialog_count;
              this.jj_sure_count = data.jj_sure_count;
              this.jj_cost_price = Math.round(data.jj_cost_price); // 赵国梁说不已万为单位
              this.jj_in_base = Math.round(data.jj_in_base);
              this.jj_dialog_base = Math.round(data.jj_dialog_base);
              this.jj_sure_base = Math.round(data.jj_sure_base);
              this.jj_in_rate = Math.round((data.jj_in_count / data.jj_dialog_count) * 100).toFixed(2);
              this.jj_in_rate = isNaN(this.jj_in_rate) ? 0 : this.jj_in_rate;
              this.jj_in_rate = this.jj_in_rate == "Infinity" ? "-" : this.jj_in_rate;
              jjArr.push({
                in_count: this.jj_in_count,
                dialog_count: this.jj_dialog_count,
                cost_price: this.jj_cost_price,
                sure_count: this.jj_sure_count
              });
              this.jjArr = jjArr;
              // 优化
              this.yh_in_count = data.yh_in_count;
              this.yh_dialog_count = data.yh_dialog_count;
              this.yh_sure_count = data.yh_sure_count;
              this.yh_cost_price = Math.round(data.yh_cost_price);
              this.yh_in_base = Math.round(data.yh_in_base);
              this.yh_dialog_base = Math.round(data.yh_dialog_base);
              this.yh_sure_base = Math.round(data.yh_sure_base);
              this.yh_in_rate = Math.round((data.yh_in_count / data.yh_dialog_count) * 100).toFixed(2);
              this.yh_in_rate = isNaN(this.yh_in_rate) ? 0 : this.yh_in_rate;
              this.yh_in_rate = this.yh_in_rate == "Infinity" ? "-" : this.yh_in_rate;
              yhArr.push({
                in_count: this.yh_in_count,
                dialog_count: this.yh_dialog_count,
                sure_count: this.yh_sure_count,
                cost_price: this.yh_cost_price
              });
              this.yhArr = yhArr;

              // 门户
              this.mh_in_count = data.mh_in_count;
              this.mh_dialog_count = data.mh_dialog_count;
              this.mh_sure_count = data.mh_sure_count;
              this.mh_cost_price = Math.round(data.mh_cost_price);
              this.mh_in_base = Math.round(data.mh_in_base);
              this.mh_dialog_base = Math.round(data.mh_dialog_base);
              this.mh_sure_base = Math.round(data.mh_sure_base);
              this.mh_in_rate = Math.round((data.mh_in_count / data.mh_dialog_count) * 100).toFixed(2);
              this.mh_in_rate = isNaN(this.mh_in_rate) ? 0 : this.mh_in_rate;
              this.mh_in_rate = this.mh_in_rate == "Infinity" ? "-" : this.mh_in_rate;
              mhArr.push({
                in_count: this.mh_in_count,
                dialog_count: this.mh_dialog_count,
                sure_count: this.mh_sure_count,
                cost_price: this.mh_cost_price
              });
              this.mhArr = mhArr;

              // 新媒体
              this.xmt_in_count = data.xmt_in_count;
              this.xmt_dialog_count = data.xmt_dialog_count;
              this.xmt_sure_count = data.xmt_sure_count;
              this.xmt_cost_price = Math.round(data.xmt_cost_price);
              this.xmt_in_base = Math.round(data.xmt_in_base);
              this.xmt_dialog_base = Math.round(data.xmt_dialog_base);
              this.xmt_sure_base = Math.round(data.xmt_sure_base);
              this.xmt_in_rate = Math.round((data.xmt_in_count / data.xmt_dialog_count)* 100).toFixed(2);
              this.xmt_in_rate = isNaN(this.xmt_in_rate) ? 0 : this.xmt_in_rate;
              this.xmt_in_rate = this.xmt_in_rate == "Infinity" ? "-" : this.xmt_in_rate;
              xmtArr.push({
                in_count: this.xmt_in_count,
                dialog_count: this.xmt_dialog_count,
                sure_count: this.xmt_sure_count,
                cost_price: this.xmt_cost_price
              });
              this.xmtArr = xmtArr;

              // 资源合作
              this.zyhz_in_count = data.zyhz_in_count;
              this.zyhz_dialog_count = data.zyhz_dialog_count;
              this.zyhz_sure_count = data.zyhz_sure_count;
              this.zyhz_cost_price = Math.round(data.zyhz_cost_price);
              this.zyhz_in_base = Math.round(data.zyhz_in_base);
              this.zyhz_dialog_base = Math.round(data.zyhz_dialog_base);
              this.zyhz_sure_base = Math.round(data.zyhz_sure_base);
              this.zyhz_in_rate = Math.round((data.zyhz_in_count / data.zyhz_dialog_count) * 100).toFixed(2);
              this.zyhz_in_rate = isNaN(this.zyhz_in_rate)
                ? 0
                : this.zyhz_in_rate;
              this.zyhz_in_rate = this.zyhz_in_rate == "Infinity" ? "-" : this.zyhz_in_rate;

              zyhzArr.push({
                in_count: this.zyhz_in_count,
                dialog_count: this.zyhz_dialog_count,
                sure_count: this.zyhz_sure_count,
                cost_price: this.zyhz_cost_price
              });
              this.zyhzArr = zyhzArr;

              // 无轨迹
              this.wgj_in_count = data.wgj_in_count;
              this.wgj_dialog_count = data.wgj_dialog_count;
              this.wgj_sure_count = data.wgj_sure_count;
              this.wgj_cost_price = Math.round(data.wgj_cost_price);
              this.wgj_in_base = Math.round(data.wgj_in_base);
              this.wgj_dialog_base = Math.round(data.wgj_dialog_base);
              this.wgj_sure_base = Math.round(data.wgj_sure_base);
              this.wgj_in_rate = Math.round((data.wgj_in_count / data.wgj_dialog_count) * 100).toFixed(2);
              this.wgj_in_rate = isNaN(this.wgj_in_rate) ? 0 : this.wgj_in_rate;
              this.wgj_in_rate = this.wgj_in_rate == "Infinity" ? "-" : this.wgj_in_rate;

              wgjArr.push({
                in_count: this.wgj_in_count,
                dialog_count: this.wgj_dialog_count,
                sure_count: this.wgj_sure_count,
                cost_price: this.wgj_cost_price
              });
              this.wgjArr = wgjArr;

              // 其他
              this.qt_in_count = data.qt_in_count;
              this.qt_dialog_count = data.qt_dialog_count;
              this.qt_sure_count = data.qt_sure_count;
              this.qt_cost_price = Math.round(data.qt_cost_price);
              this.qt_in_base = Math.round(data.qt_in_base);
              this.qt_dialog_base = Math.round(data.qt_dialog_base);
              this.qt_sure_base = Math.round(data.qt_sure_base);
              this.qt_in_rate = Math.round((data.qt_in_count / data.qt_dialog_count) * 100).toFixed(2);
              this.qt_in_rate = isNaN(this.qt_in_rate) ? 0 : this.qt_in_rate;
              this.qt_in_rate = this.qt_in_rate == "Infinity" ? "-" : this.qt_in_rate;

              qtArr.push({
                in_count: this.qt_in_count,
                dialog_count: this.qt_dialog_count,
                sure_count: this.qt_sure_count,
                cost_price: this.qt_cost_price
              });
              this.qtArr = qtArr;
            } else {
              // 竞价
              this.dataShow = true
              this.jj_in_count = "";
              this.jj_dialog_count = "";
              this.jj_sure_count = "";
              this.jj_cost_price = "";
              this.jj_in_base = "";
              this.jj_dialog_base = "";
              this.jj_sure_base = "";
              // 优化
              this.yh_in_count = "";
              this.yh_dialog_count = "";
              this.yh_sure_count = "";
              this.yh_cost_price = "";
              this.yh_in_base = "";
              this.yh_dialog_base = "";
              this.yh_sure_base = "";
              // 门户
              this.mh_in_count = "";
              this.mh_dialog_count = "";
              this.mh_sure_count = "";
              this.mh_cost_price = "";
              this.mh_in_base = "";
              this.mh_dialog_base = "";
              this.mh_sure_base = "";
              // 新媒体
              this.xmt_in_count = "";
              this.xmt_dialog_count = "";
              this.xmt_sure_count = "";
              this.xmt_cost_price = "";
              this.xmt_in_base = "";
              this.xmt_dialog_base = "";
              this.xmt_sure_base = "";
              // 资源合作
              this.zyhz_in_count = "";
              this.zyhz_dialog_count = "";
              this.zyhz_sure_count = "";
              this.zyhz_cost_price = "";
              this.zyhz_in_base = "";
              this.zyhz_dialog_base = "";
              this.zyhz_sure_base = "";
              // 无轨迹
              this.wgj_in_count = "";
              this.wgj_dialog_count = "";
              this.wgj_sure_base = "";
              this.wgj_cost_price = "";
              this.wgj_in_base = "";
              this.wgj_dialog_base = "";
              this.wgj_sure_base = "";

              // 其他
              this.qt_in_count = "";
              this.qt_dialog_count = "";
              this.qt_sure_count = "";
              this.qt_cost_price = "";
              this.qt_in_base = "";
              this.qt_dialog_base = "";
              this.qt_sure_base = "";
            }
          } else if (result.ret == 403) {
            this.$message.error(result.msg);
          }
        });
    }
  },
  mounted() {
    this.getHospInfo(() => {
      this.getDayList();
    });
  }
};
</script>

<style lang="stylus" scoped>
.clearfix {
  text-align: center;
}

table
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
  border:1px solid #d7d7d7
  thead th {
    text-align: center;
    padding: 10px;
    border:1px solid #d7d7d7
  }
  thead th:first-child {
    text-align: left;
    border:1px solid #d7d7d7
  }
  tbody td {
    padding: 10px;
    border:1px solid #d7d7d7
  }
</style>
<style lang="stylus">
.el-input__inner {
  -webkit-appearance: none !important;
  background-color: #FFF !important;
  background-image: none !important;
  border-radius: 4px !important;
  border: 1px solid #DCDFE6 !important;
  -webkit-box-sizing: border-box !important;
}

.upload-demo {
  display: inline-block;
}

.el-dialog__body {
  padding: 10px 20px;

  .dialog_head {
    padding-bottom: 20px;
    font-size: 14px;

    .value {
      padding-right: 20px;
    }

    .value_name {
      padding-right: 20px;
    }
  }

  .total {
    font-size: 14px;
    text-align: center;

    .total-left {
      margin: 25px;
      display: flex;
      justify-content: space-between;

      span {
        span {
          color: #0066FF;
          padding: 0 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enter-plan/index.vue